import { newStorage } from './storage';

const topicsTableStorage = newStorage('TABLE_TOPICS');

export default topicsTableStorage;
